var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8253_2898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4901 3.75023H11.1971C11.1971 3.31852 10.8612 2.79688 10.4464 2.79688H7.82026C7.40559 2.79688 7.0697 3.31852 7.0697 3.75023H4.77671C4.27064 3.75023 3.71289 3.82583 3.71289 4.33287V5.1173H14.2897V4.33287C14.2898 3.82585 13.997 3.75023 13.4901 3.75023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 6.03467V13.5048C4.64844 14.2643 5.39315 15.1905 6.15269 15.1905H12.1144C12.8748 15.1905 13.3725 14.2643 13.3725 13.5048V6.03467H4.64844ZM7.15349 13.661H6.2357V7.0508H7.15349V13.661ZM9.45244 13.661H8.53465V7.0508H9.45244V13.661ZM11.7514 13.661H10.8336V7.0508H11.7514V13.661Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8253_2898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b2cad3d5813cdd9d5f866fbb26d02cc6.svg";
export { ForwardRef as ReactComponent };